
import XButton from 'vux/src/components/x-button/index.vue'
import Card from 'vux/src/components/card/index.vue'

import moment from 'moment';
import {queryChartData} from "@/api/deviceData";
import { DatePicker } from 'ant-design-vue'
export default {
name: 'historyData',
components: {
DatePicker,
Card,
XButton
},
data() {
return {
devId: '',
slaveIndex: 0,
dataId: '',
startTime: moment(moment().add(-2,'hours'), 'HH:mm:ss'),
endDate: moment(moment(), 'YYYY-MM-DD'),
startDate: moment(moment(), 'YYYY-MM-DD'),
endTime: moment(moment(), 'HH:mm:ss')
}
},
mounted() {
this.devId = this.$route.query.devId;
this.dataId = this.$route.query.dataId;
this.getDataHisByTimePeriod();
},
methods: {
moment,
seconds(date){
let now = new Date(date);
let ss = now.getTime() / 1000;
ss = Math.floor(ss);
return ss;
},
getDataHisByTimePeriod() {
let params = {
deviceId: this.devId,
pointIds: [this.dataId],
startTime: this.startDate.format('YYYY-MM-DD')+' '+this.startTime.format('HH:mm:ss'),
endTime: this.endDate.format('YYYY-MM-DD')+' '+this.endTime.format('HH:mm:ss')
}
queryChartData(params).then(response => {
let deviceDataList = response.data && response.data.dataPoints;
this.drawLine(deviceDataList);
});
},
drawLine(list){
let date = [];
let data = [];
let name = "";
if (list && list.length > 0) {
name = list[0].pointName;
let devDatas = list[0].datas;
if (devDatas) {
devDatas.forEach(item => {
date.push(this.moment(item.createTime).format('MM-DD HH:mm:ss'));
data.push(item.value);
})
}
}

let myChart = this.$echarts.init(document.getElementById('myChart'))

myChart.setOption({
tooltip: {
trigger: 'axis',
position: function (pt) {
return [pt[0], '10%'];
}
},
title: {
left: 'center',
text: '历史数据',
},
toolbox: {
feature: {



dataView:{},
restore: {},
saveAsImage: {}
}
},
xAxis: {
type: 'category',
boundaryGap: false,
data: date,
axisLabel: {
formatter:function(value){
return value.split(' ')[0]+'\n'+value.split(' ')[1]
},

}
},
yAxis: {
type: 'value',
boundaryGap: [0, '100%']
},
dataZoom: [{
type: 'inside',
start: 0,
end: 10
}, {
start: 0,
end: 10,
handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
handleSize: '80%',
handleStyle: {
color: '#fff',
shadowBlur: 3,
shadowColor: 'rgba(0, 0, 0, 0.6)',
shadowOffsetX: 2,
shadowOffsetY: 2
}
}],
series: [
{
name:name,
type:'line',
smooth:true,
symbol: 'none',
sampling: 'average',
itemStyle: {
color: 'rgb(255, 70, 131)'
},
data: data
}
]
});
}
}
}



// WEBPACK FOOTER //
// ./src/components/history-data.vue